import * as types from './index';


export const eventListAction = (data) => {
    return {
        type: types.EVENT_LIST,
        data
    }
};

export const eventClientListAction = (data) => {
    return {
        type: types.QUOTE_CLIENT_LIST,
        data
    }
};

export const quoteEventLocationListAction = (data) => {
    return {
        type: types.QUOTE_EVENT_LOCATION_LIST,
        data
    }
};

export const eventAddAction = (data) => {
    return {
        type: types.EVENT_ADD,
        data
    }
};

export const eventEditAction = (data) => {
    return {
        type: types.EVENT_EDIT,
        data
    }
};

export const eventUpdateAction = (data) => {
    return {
        type: types.EVENT_UPDATE,
        data
    }
};

export const eventDeleteAction = (data) => {
    return {
        type: types.EVENT_DELETE,
        data
    }
};

export const eventCancelAction = (data) => {
    return {
        type: types.EVENT_CANCEL,
        data
    }
};

export const quoteAcceptAction = (data) => {
    return {
        type: types.QUOTE_ACCEPT,
        data
    }
};
export const quoteRejectAction = (data) => {
    return {
        type: types.QUOTE_REJECT,
        data
    }
};

export const quoteRequestAction = (data) => {
    return {
        type: types.QUOTE_REQUEST,
        data
    }
};

export const quoteAssUserListAction = (data) => {
    return {
        type: types.QUOTE_ASS_USER_LIST,
        data
    }
};

export const shiftAddAction = (data) => {
    return {
        type: types.SHIFT_ADD,
        data
    }
};

export const shiftCancelAction = (data) => {
    return {
        type: types.SHIFT_CANCEL,
        data
    }
};

export const eventClientDetailsAction = (data) => {
    return {
        type: types.EVENT_CLIENT_DETAILS,
        data
    }
};

export const generateInvoiceAction = (data) => {
    return {
        type: types.GENERATE_INVOICE,
        data
    }
};

export const eventAffiliateDetailsAction = (data) => {
    return {
        type: types.EVENT_AFFILIATE_DETAILS,
        data
    }
};

export const eventQuoteSummaryAction = (data) => {
    return {
        type: types.EVENT_QUOTE_SUMMARY,
        data
    }
};

export const eventQuotePreviewAction = (data) => {
    return {
        type: types.EVENT_QUOTE_PREVIEW,
        data
    }
};

export const eventSummaryAction = (data) => {
    return {
        type: types.EVENT_SUMMARY,
        data
    }
};


export const eventGetCrewChiefCountAction = (data) => {
    return {
        type: types.EVENT_CREW_CHIEF_COUNT,
        data
    }
};

export const shiftIndividualDetailsAction = (data) => {
    return {
        type: types.SHIFT_INDIVIDUAL_DETAILS,
        data
    }
};

export const shiftEditAction = (data) => {
    return {
        type: types.SHIFT_EDIT,
        data
    }
};

export const quoteSendtoClientAction = (data) => {
    return {
        type: types.QUOTE_SEND_CLIENT,
        data
    }
};

export const invoiceSendtoClientAction = (data) => {
    return {
        type: types.INVOICE_SEND_CLIENT,
        data
    }
};

export const eventUserLogsListAction = (data) => {
    return {
        type: types.QUOTE_USER_ACTION_LOG,
        data
    }
};

export const shiftListAction =(data) =>{
    return {
        type: types.SHIFT_LIST,
        data
    }
}

export const shiftDeleteAction =(data) =>{
    return {
        type: types.SHIFT_DELETE,
        data
    }
}


export const quoteQuickUpdateAction =(data) =>{
    return {
        type: types.SHIFT_QUICK_UPDATE,
        data
    }
}

export const quoteDownloadAction =(data) =>{
    return {
        type: types.QUOTE_DOWNLOAD,
        data
    }
} 

export const invoiceDownloadAction =(data) =>{
    return {
        type: types.INVOICE_DOWNLOAD,
        data
    }
}

export const eventUpdateShiftAction =(data) =>{
    return {
        type: types.EVENT_SHIFT_UPDATE,
        data
    }
}

export const eventClientAffiliateListAction =(data) =>{
    return {
        type: types.EVENT_CLIENT_AFFILIATE_LIST,
        data
    }
}

export const eventCalendarListAction =(data) =>{
    return {
        type: types.EVENTS_CALENDAR_LIST,
        data
    }
}

export const shiftSummaryAction =(data) =>{ // FOR SLIDER, FROM SHIFT LISING - NOW USED FOR SHIFT OVERVIEW
    return {
        type: types.SHIFT_SUMMARY,
        data
    }
}

export const shiftSummaryAllCrewAction =(data) =>{ // FOR SLIDER, FROM SHIFT LISING - USED FOR SHIFT SUMMARY
    return {
        type: types.SHIFT_SUMMARY_ALL_CREW,
        data
    }
}

export const shiftGetDetailsAction = (data) => {
    return {
        type: types.SHIFT_GET_DETAILS,
        data
    }
};

export const shiftScheduleListAction =(data) =>{ 
    return {
        type: types.SHIFT_SCHEDULE_LIST,
        data
    }
}

export const shiftScheduleCrewAction =(data) =>{ 
    return {
        type: types.SHIFT_SCHEDULE_CREW,
        data
    }
}

export const scheduleShiftCrewAction =(data) =>{ 
    return {
        type: types.SCHEDULE_SHIFT_CREW,
        data
    }
}

export const shiftScheduleCrewRequestAction =(data) =>{ 
    return {
        type: types.SHIFT_SCHEDULE_CREW_SEND_REQUEST,
        data
    }
}

export const shiftSkillCrewListAction =(data) =>{ 
    return {
        type: types.SHIFT_SKILL_CREW_LIST,
        data
    }
}

export const scheduleDateViewAction = (data) => { 
    return {
        type: types.SCHEDULE_DATE_VIEW,
        data
    }
}; 

export const scheduleCrewViewAction = (data) => {
    return {
        type: types.SCHEDULE_CREW_VIEW,
        data
    }
};

export const sendShiftIdsForScheduleAction =(data) =>{ 
    return {
        type: types.GET_SHIFT_IDS_FOR_SCHEDULE,
        data
    }
}

export const clearShiftIdsForScheduleAction =(data) =>{ 
    return {
        type: types.CLEAR_SHIFT_IDS_FOR_SCHEDULE,
        data
    }
}

export const filterClientsListAction = (data) => {
    return {
        type: types.FILTER_CLIENTS_LIST,
        data
    }
};

export const shiftsFilterEventsListAction = (data) => {
    return {
        type: types.SHIFTS_FILTER_EVENTS_LIST,
        data
    }
};

export const shiftsFilterShiftsListAction = (data) => {
    return {
        type: types.SHIFTS_FILTER_SHIFTS_LIST,
        data
    }
};

export const shiftsFilterLocationsListAction = (data) => {
    return {
        type: types.SHIFTS_FILTER_LOCATIONS_LIST,
        data
    }
};

export const eventsFilterEventsListAction = (data) => {
    return {
        type: types.EVENTS_FILTER_EVENTS_LIST,
        data
    }
};

export const eventsFilterLocationsListAction = (data) => {
    return {
        type: types.EVENTS_FILTER_LOCATIONS_LIST,
        data
    }
};

export const getNextShiftSeqNumberAction = (data) => {
    return {
        type: types.SHIFT_SEQ_NUMBER,
        data
    }
};

export const eventPopupIdSetAction = (data) => {
    return {
        type: types.EVENT_POPUP_ID_SET,
        data
    }
};

export const eventPopupIdResetAction = (data) => { 
    return {
        type: types.EVENT_POPUP_ID_RESET,
        data
    }
};

export const shiftPopupIdSetAction = (data) => {
    return {
        type: types.SHIFT_POPUP_ID_SET, 
        data
    }
};

export const shiftPopupIdResetAction = (data) => { 
    return {
        type: types.SHIFT_POPUP_ID_RESET, 
        data
    }
};

export const eventCompleteAction = (data) => { 
    return {
        type: types.EVENT_COMPLETE, 
        data
    }
};

export const editQuoteDiscountAction = (data) => { 
    return {
        type: types.EVENT_DISCOUNT_EDIT, 
        data
    }
};

export const eventListDownloadAction = (data) => {
    return {
        type: types.EVENT_LIST_DOWNLOAD,
        data
    }
};

export const invoiceListDownloadAction = (data) => {
    return {
        type: types.INVOICE_LIST_DOWNLOAD,
        data
    }
};

export const scheduleSetHeaderFromToDateAction = (data) => { // FOR SCHDULE PAGE HEADER 
    return {
        type: types.SCHEDULE_SET_SUB_TITLE_FROM_TO_DATE,
        data
    }
};

export const filterAffiliatesListAction = (data) => { // FOR SA PAGE EVENTS FILTER
    return {
        type: types.FILTER_AFFILIATE_LIST,
        data
    }
};

export const listEventShiftsAction = (data) => { // FOR SA PAGE EVENTS FILTER
    return {
        type: types.EVENT_SHIFTS_LIST,
        data
    }
};

export const listEventShiftCrewAction = (data) => { // FOR SA PAGE EVENTS FILTER
    return {
        type: types.EVENT_SHIFT_CREW_LIST,
        data
    }
};

export const schedulesDateViewCalendarAction = (data) => { // FOR SA PAGE EVENTS FILTER
    return {
        type: types.SCHEDULE_DATE_VIEW_CALENDAR,
        data
    }
};

export const schedDateViewCalendarDateAction = (data) => { // FOR SA PAGE EVENTS FILTER
    return {
        type: types.SCHED_DATE_VIEW_CALENDAR_DATE,
        data
    }
};

export const shifCrewListDownloadAction = (data) => { // FOR SA PAGE EVENTS FILTER
    return {
        type: types.SHIFT_CREW_LIST_DOWNLOAD,
        data
    }
};

export const eventShiftsStaffListPDFDownloadAction = (data) => { // FOR SA PAGE EVENTS FILTER
    return {
        type: types.EVENT_SHIFTS_STAFF_LIST_PDF_DOWNLOAD,
        data
    }
};

export const listEventMessagesAction = (data) => { //for MESSAGES
    return {
        type: types.EVENT_MESSAGES_LIST,
        data
    }
};

export const sendEventMessageAction = (data) => { //for MESSAGES
    return {
        type: types.SEND_EVENT_MESSAGE,
        data
    }
};

export const shiftTimeChangeRequestAction = (data) => {  
    return {
        type: types.SHIFT_TIME_CHANGE_REQUEST,
        data
    }
};

export const getUnallocatedShiftsCountAction = (data) => {  
    return {
        type: types.UNALLOCATED_SHIFTS_COUNT,
        data
    }
};

export const addRemoveVehicleAction = (data) => {  
    return {
        type: types.ADD_REMOVE_VEHICLE,
        data
    }
};
export const addRemoveVehicleFromShiftAction = (data) => {  
    return {
        type: types.ADD_REMOVE_VEHICLE_SHIFT,
        data
    }
};

export const listInvoiceAction = (data) => {  
    return {
        type: types.LIST_INVOICE,
        data
    }
};

export const updateInvoiceAction = (data) => {  
    return {
        type: types.UPDATE_INVOICE,
        data
    }
};
export const invoicePreviewAction = (data) => {  
    return {
        type: types.INVOICE_PREVIEW,
        data
    }
};
export const availableAffVehicleAction = (data) => {  
    return {
        type: types.AVAILABLE_AFF_VEHICLE,
        data
    }
};
export const addAffVehicleAction = (data) => {  
    return {
        type: types.ADD_AFF_VEHICLE,
        data
    }
};
export const removeAffVehicleAction = (data) => {  
    return {
        type: types.REMOVE_AFF_VEHICLE,
        data
    }
};
export const addAffVehicleShiftAction = (data) => {  
    return {
        type: types.ADD_AFF_VEHICLE_SHIFT,
        data
    }
};
export const removeAffVehicleShiftAction = (data) => {  
    return {
        type: types.REMOVE_AFF_VEHICLE_SHIFT,
        data
    }
};
export const cancelReasonsListAction = (data) => {  
    return {
        type: types.CANCELLED_REASON_LIST,
        data
    }
};
export const crewAvailabilityReportAction = (data) => {  
    return {
        type: types.CREW_AVAILABILITY_REPORT,
        data
    }
};

export const clientDepartmentsByEventIdAction = (data) => {   
    return {
        type: types.EVENT_CLIENT_DEPARTMENTS_LIST,
        data
    }
};

export const crewAvailSummaryReportListAction = (data) => {  
    return {
        type: types.CREW_AVAIL_SUMMARY_REPORT,
        data
    }
};

export const shiftCalendarEventsListAction = (data) => {  
    return {
        type: types.SHIFT_CALENDAR_EVENT_LIST, 
        data
    }
}; 

export const shiftCalendarEventShiftsListAction = (data) => {  
    return {
        type: types.SHIFT_CALENDAR_EVENT_SHIFT_LIST, 
        data
    }
};

export const shiftCalcDistanceDeptLocAction = (data) => {  
    return {
        type: types.SHIFT_CALC_DISTANCE_DEPT_LOC, 
        data
    }
};


